import { initialDataParser } from "@kano/utilities/initialData";
import { i18n, initPublicMessages } from '@kano/i18n';
import Vue from "vue";
import CryptoPriceChartApp from "@kano/components/CryptoPriceChart/CryptoPriceChartApp.vue";

let appInstance: Vue|null = null;
export const mountPriceChartApp = async () => {
  if (appInstance !== null) {
    appInstance.$destroy();
  }

  const el = document.getElementById('crypto-price-chart-app');
  const { props } = initialDataParser('priceChart', ['props']);
  if (!el || !props) {
    return;
  }

  await initPublicMessages();

  appInstance = new Vue({
    i18n,
    render: h => h(CryptoPriceChartApp, {
      props,
    }),
  }).$mount(el);

  // Reinitialize tooltips after the content is updated
  if (window?.initializeTooltips) {
    window?.initializeTooltips();
  }
};

mountPriceChartApp();